export default __webpack_public_path__ + "static/media/PERA.13589fea.png";